import React from 'react'
import styled from 'styled-components'
import { media } from 'tools/browser'
import PropTypes from 'prop-types'

export const noopHref = 'javascript:void(0)' // eslint-disable-line no-script-url

const ButtonLink = styled.a`
    background-color: ${props => props.theme === 'primary' ? 'rgba(85, 188, 189, 1)' : 'rgba(75, 85, 94, 1)'};
    border: 2px solid ${props => props.theme === 'primary' ? 'rgba(85, 188, 189, 1)' : 'rgba(109, 124, 138, 1)'};
    border-radius: 6px;
    padding: 12px 32px;
    color: #FFF;
    line-height: 16px;
    text-align: center;
    text-decoration: none;

    &:hover, &:active, &:link {
        background-color: ${props => props.theme === 'primary' ? 'rgba(85, 188, 189, .8)' : 'rgba(90, 102, 113, 1)'};
        color: #FFF
    }

    &:visited {
        color: #FFF;
    }

    ${media.greaterThan.large`
        padding: 10px 16px;
    `}

    ${media.greaterThan.extraLarge`
        padding: 12px 32px;
    `}
`

const A = styled.a`
    text-decoration: none;
    color: ${p => p.textColor || 'inherit'};

    &:hover, &:visited, &:link {
        color: ${p => p.textColor || 'inherit'};
    }

    &:hover {
      cursor: ${props => (!!props.href && props.href !== noopHref) ? 'pointer' : 'default'};
    }
`

function Link (props) {
  const { type, children, data, theme, textColor, ...anchorProps } = props
  const dataAttrs = data || {}
  if (children === undefined) {
    throw new Error('this component requires children')
  }

  if (type === 'button') {
    return (
      <ButtonLink {...anchorProps} {...dataAttrs} theme={theme}>
        {children}
      </ButtonLink>
    )
  }
  return (
    <A {...anchorProps} {...dataAttrs} textColor={textColor}>
      {children}
    </A>
  )
}

Link.propTypes = {
  type: PropTypes.oneOf(['button', 'link']).isRequired,
  children: PropTypes.node.isRequired,
  data: PropTypes.object,
  theme: PropTypes.string,
  textColor: PropTypes.string,
}

Link.defaultProps = {
  type: 'link',
}

export default Link



// WEBPACK FOOTER //
// ./src/atoms/Link/Link.js